import { grid } from "ldrs";
import { Paragraph } from "../../Commons/Paragraph";

grid.register();
export default function TradeAnalyzeLoading() {
  return <l-grid size="75" speed="1.5" color="#448585"></l-grid>;
}
